import { ErrorModal } from "@dexteel/mesf-core";
import { Grid2 as Grid } from "@mui/material";
import {
	DefaultMenuItem,
	GetContextMenuItemsParams,
	MenuItemDef,
	RowClassParams,
} from "ag-grid-community";

import { AgGridReact } from "ag-grid-react";
import { useEffect } from "react";
import { useDelaysReportContext } from "../context/DelaysReportContext";
import { DelayByShift } from "../models/DelayByShift";
import { useGridStyles } from "../styles/gridStyles";
import { useTableData } from "./hooks";

type Props = {
	loadingGrid: boolean;
	rows: DelayByShift[];
	refreshData: Function;
	gridRef: React.RefObject<AgGridReact>;
};

export const DelaysReportTable = ({ loadingGrid, rows, gridRef }: Props) => {
	const gridStyles = useGridStyles();
	const { columns } = useTableData();

	const {
		state: {
			anchorPoint: { x, y },
			errorMessage,
		},
		actions: { setErrorMessage },
	} = useDelaysReportContext();

	const getRowStyle = (params: RowClassParams) => {
		if (!params.data.IsActive || params.data.IsMicroDelay) {
			return { background: "#E8EBEB" };
		}
		if (!params.data.DelayCodeName || !params.data.DelayCategoryName) {
			return { background: "#E8C8C8" };
		}
	};

	useEffect(() => {
		if (
			loadingGrid &&
			gridRef.current !== null &&
			gridRef.current.api !== undefined
		) {
			gridRef.current!.api.showLoadingOverlay();
		} else if (gridRef.current !== null && gridRef.current.api !== undefined) {
			gridRef.current!.api.hideOverlay();
		}
	}, [loadingGrid]);

	const getContextMenuItems = (
		params: GetContextMenuItemsParams,
	): (DefaultMenuItem | MenuItemDef)[] => {
		const data = params.node?.data;

		const addNewDelay: (DefaultMenuItem | MenuItemDef)[] = [];

		return addNewDelay;
	};

	return (
		<div onContextMenu={(e) => e.preventDefault()}>
			<div>
				<Grid container className={gridStyles.root}>
					<Grid
						size={{ xs: 12, md: 12 }}
						style={{
							border: "1px solid #ccc",
							borderRadius: "4px",
							minHeight: "75vh",
						}}
					>
						<AgGridReact
							ref={gridRef}
							rowSelection="single"
							pagination={false}
							animateRows={true}
							rowHeight={35}
							headerHeight={35}
							singleClickEdit={true}
							tooltipShowDelay={0}
							tooltipHideDelay={2000}
							rowData={rows}
							columnDefs={columns}
							getContextMenuItems={getContextMenuItems}
							getRowStyle={getRowStyle}
						/>
					</Grid>
				</Grid>
			</div>
			<ErrorModal error={errorMessage} onHide={() => setErrorMessage("")} />
		</div>
	);
};
